const PredicateTypes = {
	// RR types
	'id': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')}
	],
	'text': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')}
	],
	'string_extra': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')}
	],
	'datasource': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')}
	],
	'boolean': [
		{type: 'noop', value: 'yes', label: gettext('Value is true')},
		{type: 'noop', value: 'no', label: gettext('Value is false')}
	],
	'rankedby': [
		{type: 'choice', value: 'yes', label: gettext('Value is true for')},
		{type: 'choice', value: 'no', label: gettext('Value is not true for')}
	],
	'task': [
		{type: 'noop', value: 'yes', label: gettext('Value is complete')},
		{type: 'noop', value: 'no', label: gettext('Value is not complete')}
	],
	'select': [
		{type: 'choice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of')},
		{type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of')}
	],
	'text_choice': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')},
		{type: 'choice', value: 'equals_var', label: gettext('Value equals custom field')},
		{type: 'choice', value: 'contains_var', label: gettext('Value contains custom field')}
	],
	'smarttext': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')},
		{type: 'choice', value: 'equals_reviewer_information', label: gettext('Value equals reviewer information')}
	],
	'datecreated': [
		{type: 'datetime', value: 'before', label: gettext('Date is before')},
		{type: 'datetime', value: 'after', label: gettext('Date is after')},
		{type: 'datetime', value: 'equals', label: gettext('Date is exactly')}
	],
	'responseedited': [
		{type: 'datetime', value: 'before', label: gettext('Date is before')},
		{type: 'datetime', value: 'after', label: gettext('Date is after')},
		{type: 'datetime', value: 'equals', label: gettext('Date is exactly')}
	],
	'team_metadata': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')},
		{type: 'choice', value: 'award_property', label: gettext('Value equals award property')}
	],

	'categories': [
		{type: 'noop', value: 'nocategory', label: gettext('Value has no category')},
		{type: 'noop', value: 'hascategory', label: gettext('Value has a category')},
		{type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of')},
		{type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of')},
		{type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly')}
	],

	'money': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'greaterthan', label: gettext('Value is greater than')},
		{type: 'text', value: 'lessthan', label: gettext('Value is less than')}
	],

	// FS types
	'string': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')},
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'notequals', label: gettext('Value is not')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')},
		{type: 'text', value: 'greaterthan', label: gettext('Value is greater than')},
		{type: 'text', value: 'lessthan', label: gettext('Value is less than')}
	],
	'single': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')},
		{type: 'choice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'choice', value: 'notequals', label: gettext('Value is not')},
		{type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of')},
		{type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of')},
	],
	'multi': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')},
		{type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of')},
		{type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of')},
		{type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'multiplechoice', value: 'notequals', label: gettext('Value is not')},
	],
	'checkbox': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')},
		{type: 'noop', value: 'yes', label: gettext('Value was checked')},
		{type: 'noop', value: 'no', label: gettext('Value was not checked')}
	],
	'datetime': [
		{type: 'noop', value: 'noresponse', label: gettext('Date has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Date has a response')},
		{type: 'datetime', value: 'before', label: gettext('Date is before')},
		{type: 'datetime', value: 'after', label: gettext('Date is after')},
		{type: 'datetime', value: 'equals', label: gettext('Date is exactly')},
	],
	'hidden': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')},
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'notequals', label: gettext('Value is not')},
		{type: 'text', value: 'contains', label: gettext('Value contains ')},
		{type: 'text', value: 'greaterthan', label: gettext('Value is greater than')},
		{type: 'text', value: 'lessthan', label: gettext('Value is less than')}
	],


	//SMAPPLY CLEANED UP TYPES THAT SUPPORT MULTITYPE-TYPES
	'date': [
		{type: 'datetime', value: 'before', label: gettext('Date is before')},
		{type: 'datetime', value: 'after', label: gettext('Date is after')},
		{type: 'datetime', value: 'equals', label: gettext('Date is exactly')},
		{type: 'datetime', value: 'notequals', label: gettext('Date is not')},
	],
	'list': [
		{type: 'choice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'choice', value: 'notequals', label: gettext('Value is not')},
		{type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of')},
		{type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of')},
	],
	'text': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'notequals', label: gettext('Value is not')},
		{type: 'text', value: 'contains', label: gettext('Value contains')},
		{type: 'text', value: 'doesnotcontain', label: gettext('Value does not contain')},
	],
	'number': [
		{type: 'text', value: 'equals', label: gettext('Value is exactly')},
		{type: 'text', value: 'notequals', label: gettext('Value is not')},
		{type: 'text', value: 'greaterthan', label: gettext('Value is greater than')},
		{type: 'text', value: 'lessthan', label: gettext('Value is less than')},
	],
	'response': [
		{type: 'noop', value: 'noresponse', label: gettext('Value has no response')},
		{type: 'noop', value: 'hasresponse', label: gettext('Value has a response')}
	],
	'multilist': [
		{type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of')},
		{type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of')},
		{type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'multiplechoice', value: 'notequals', label: gettext('Value is not')},
	],
	'booleanlist': [
		{type: 'choice', value: 'yes', label: gettext("Is true")},
		{type: 'choice', value: 'no', label: gettext("Is false")}
	],
	'number_and_multilist': [
		{type: 'value_and_multi', value: 'equals', label: gettext('Value is exactly')},
		{type: 'value_and_multi', value: 'notequals', label: gettext('Value is not')},
		{type: 'value_and_multi', value: 'greaterthan', label: gettext('Value is greater than')},
		{type: 'value_and_multi', value: 'lessthan', label: gettext('Value is less than')},
	],
	'status_and_payment': [
		{type: 'choice_and_choice', value: 'equals', label: gettext('Value is exactly')},
		{type: 'choice_and_choice', value: 'notequals', label: gettext('Value is not')},
		{type: 'multi_and_choice', value: 'isoneof', label: gettext('Value is one of')},
		{type: 'multi_and_choice', value: 'notisoneof', label: gettext('Value is not any of')}
	],
	file: [
		{type: 'noop', value: 'nofile', label: gettext('Does not have a file uploaded')},
		{type: 'noop', value: 'hasfile', label: gettext('Has a file uploaded')},
	],
	'sma-file-upload': [
		{type: 'noop', value: 'nofile', label: gettext('Does not have a file uploaded')},
		{type: 'noop', value: 'hasfile', label: gettext('Has a file uploaded')},
	],

	//SMapply custom types that are specific to scenarios
	'team_and_stage': [
		{type: 'team_and_stage', value: 'equals', label: gettext('equals')}
	],

	'select_programs': [
		{type: 'multi_with_search', value: 'isoneof', label: gettext('Selected program(s)')},
		{type: 'noop', value: 'anyprogram', label: gettext('Any program')},
	],
};

module.exports = PredicateTypes;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/filters/types.js